import React, { useEffect, useState } from "react";
import Image from "../images/Image";
import ButtonWithImg from "../buttons/ButtonWithImg";
import { useLocation, useNavigate } from "react-router";
import { RootState } from "../../store";
import { useSelector } from "react-redux";

type NotFoundProps = {
    default?: boolean; // Optional prop, currently not used
}

const NotFound: React.FC<NotFoundProps> = ({ default :isDefault }: NotFoundProps) => { 
    const navigate = useNavigate();
    const location = useLocation();
    const [routeState, setRouteState] = useState('');
    const pathUrl = useSelector((state: RootState) => state.geolocation.previousUrl);


    const handleNavigation = () => {
        if (routeState) {
            navigate(routeState); // Navigate to the route if it's provided
        } else {
            navigate(-1); // Default to homepage or another fallback
        }
    };

    useEffect(()=>{
        if(!isDefault){
            setRouteState(location?.state?.route || '');
        }else{
            setRouteState('');
        }
    },[])
    return (
        <div
            className="w-screen h-screen bg-[url('/images/404-page.png')] bg-center bg-no-repeat bg-contain flex justify-center items-center"
            style={{
                backgroundSize: "100% 100%",
            }}
        >
            <div className="bg-white px-[50px] w-fit rounded-[20px] pt-[130px] pb-[67px] flex flex-col items-center">
                <Image src="404-image" />
                <p className="text-heading1 text-primary_text mt-5">Page not found</p>
                <p className="text-title1 text-primary_text text-center mt-4">
                    Either something went wrong or the page
                    <br /> doesn’t exist
                </p>
                <ButtonWithImg
                    buttonName="Go back"
                    ImgSrc="arrow-left-circle"
                    className="bg-p_primary text-white px-8 py-4 mt-5"
                    buttonOnclick={handleNavigation}
                />
            </div>
        </div>
    );
};

export default NotFound;
